import React from 'react'

import withStyles from '@material-ui/core/styles/withStyles'

import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Collapse from '@material-ui/core/Collapse'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import CallSplitIcon from '@material-ui/icons/CallSplit'
import FontDownloadIcon from '@material-ui/icons/FontDownload'
import LensIcon from '@material-ui/icons/Lens'
import PanoramaFishEyeIcon from '@material-ui/icons/PanoramaFishEye'

import { withSize } from 'react-sizeme'
import * as constants from '../../../constants'
import { ControlButtons, DownloadImageDialog, GameInfoDialog, OperationModeMenu, RenjuBoardMenu, RenjuBoard, TurnSelectMenu, TweetDialog, SettingsDialog, ShareDialog, PuzzleInfoDialog, Word } from '../../../containers'
import { EditModeMenu } from '../..'
import { getBreakpointsEnable, getTurnTypeText, getPuzzleTypeText, getLevelIcon } from '../../../lib'
import { WID, getWord } from '../../../constants/Language';

const styles = theme => ({
  card: {
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '100%',
    maxWidth: '680px',
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  cardContent: {
    width: '100%',
    maxWidth: 680,
    paddingBottom: 0,
    paddingRight: 0,
    paddingLeft: 0,
    paddingTop: 0,
    marginTop: theme.spacing.unit,
  },
  renjuBoard: {
    width: '100%',
    height: '100%',
    position: "relative",
    margin: "0 auto",
    textAlign: "center",
    userSelect: "none",
    MozUserSelect: "none",
    MsUserSelect: "none",
    KhtmlUserSelect: "none",
    WebkitUserSelect: "none",
    WebkitTouchCallout: "none",
    WebkitTapHighlightColor: "rgba(0,0,0,0)"
  },
  board: {
    userSelect: "none",
    MozUserSelect: "none",
    MsUserSelect: "none",
    KhtmlUserSelect: "none",
    WebkitUserSelect: "none",
    WebkitTouchCallout: "none",
    WebkitTapHighlightColor: "rgba(0,0,0,0)"
  },
  analyzeAction: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: 'auto',
  },
  markAction: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  markTextFieldBox: {
    display: 'flex',
    width: '100%',
    paddingLeft: theme.spacing.unit,
    maxWidth: '400px',
    marginBottom: theme.spacing.unit,
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  markIcon: {
    margin: `0 ${theme.spacing.unit}px`
  },
  markTitle: {
    whiteSpace: 'nowrap'
  },
  markTextField: {
    alignItems: 'center',
    margin: `0 ${theme.spacing.unit * 2}px`
  },
  markButtonBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginBottom: theme.spacing.unit,
  },
  button: {
    margin: theme.spacing.unit,
  },
  stoneTypeAction: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  stoneIcon: {
    width: 16,
    height: 16,
    color: theme.palette.grey[800],
    marginRight: 8,
  },
  stoneTotalNumber: {
    color: theme.palette.grey[800],
  },
  customCardAction: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing.unit * 2,
  },
  turnAndTypeBox: {
    display: 'flex',
    justifyContent: 'center'
  },
  visibleUnderHeaderAction: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: theme.spacing.unit * 2
  },
  openingRuleBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
  },
  openingRuleSmallBox: {
    paddingLeft: theme.spacing.unit,
  },
  openingRuleViewBox: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
  },
  openingRuleChip: {
    margin: `${theme.spacing.unit * 2}px ${theme.spacing.unit}px`,
  },
  swapBox: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    margin: `${theme.spacing.unit}px 0 ${theme.spacing.unit}px 0`,
  },
  swapButton: {
    borderRadius: theme.spacing.unit * 4,
    marginLeft: theme.spacing.unit * 2,
  },
  decisionButton: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  ruleMessage: {
    marginRight: theme.spacing.unit,
  },
  numberBox: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    margin: `${theme.spacing.unit}px 0 ${theme.spacing.unit}px 0`,
  },
  numberTextField: {
    width: 75,
  },
  fiveMoveNumber: {
    fontSize: `1em`,
  },
  spaceBetweenBox: {
    paddingLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  messageBox: {
    display:' flex',
    margin: `${theme.spacing.unit * 2}px 0 ${theme.spacing.unit * 2}px 0`,
  },
  swapIconsBox: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  swapIcon: {
    color: theme.palette.grey[500],
    height: '0.75em'
  },
  popupMessageCard: {
    position: 'absolute',
    top: '46.5%',
    bottom: '53.5%',
    left: 0,
    right: 0,
    margin: 'auto',
    width: 250,
    height: 225,
    textAlign: 'left',
  },
  popupMessageCardContent: {
    textAlign: 'center',
  },
  popupMessageCardActions: {
    position: 'absolute',
    bottom: 0,
    right: 0,
  },
  swapButton2: {
    borderRadius: theme.spacing.unit * 4,
    margin: theme.spacing.unit * 2,
  },
  numberTextField2: {
    margin: theme.spacing.unit * 2,
    width: 75,
  },
  closeMessageIcon: {
    height: theme.spacing.unit * 4,
    width: theme.spacing.unit * 4,
  }
})

const RenjuBoardCardHeader = (props) => {
  const { classes, customHeaderTitle, customHeaderAction, isVisibleEditModeMenu, bid, moves, editModeMenu, isVisibleOperationMenu, type, userType, editMode, operationMode, operationModeMenu, isVisibleRenjuBoardMenu, renjuBoardMenu, handleCloseBoard, isAnalyzeMode, isMarkMode, gameInfo, settings, avatar, subheader, isVisibleUnderHeaderAction, isVisibleCardHeader } = props
  if (isVisibleCardHeader === false) {
    return (<div></div>)
  }
  var headerTitle = customHeaderTitle ? customHeaderTitle : (<div></div>)
  var headerAction = customHeaderAction ? customHeaderAction : (
    <div className={classes.cardHeader}>
      {!(isVisibleEditModeMenu === false) && (
        <EditModeMenu
          bid={bid}
          editMode={editMode}
          confirm={Boolean(moves.length > 1)}
          onSelected={editModeMenu.handleSelected}
        />
      )}
      {!(isVisibleOperationMenu === false) && (
        <OperationModeMenu
          onSelected={operationModeMenu.handleSelected}
          {...{ bid, type, userType, editMode, operationMode }}
        />
      )}
      {!(isVisibleRenjuBoardMenu === false) && (
        <RenjuBoardMenu
          onExited={renjuBoardMenu.handleExited}
          onCloseBoard={handleCloseBoard}
          onOpenAnalyzeTab={renjuBoardMenu.handleOpenAnalyzeTab}
          {...{ type, userType, editMode, isAnalyzeMode, isMarkMode, gameInfo, settings }}
        />
      )}
    </div>
  )
  var cardHeaderProps = {
    avatar,
    subheader,
    title: headerTitle,
    action: isVisibleUnderHeaderAction ? undefined : headerAction,
  }

  return (
    <React.Fragment>
      <CardHeader {...cardHeaderProps}/>
      {isVisibleUnderHeaderAction && (<div className={classes.visibleUnderHeaderAction}>{headerAction}</div>)}
    </React.Fragment>
  )
}

const AnalyzeAction = (props) => {
  const { classes, isAnalyzeMode, handleClickAnalyzeModeOff } = props
  return (
    <Collapse in={isAnalyzeMode}>
      <CardActions className={classes.analyzeAction}>
        <CallSplitIcon />
        <Typography variant="subheading" color="inherit"><Word wid={WID.RENJU_BOARD_CARD.ANALYZE_ACTION.ANALYZE}/></Typography>
        <Button color="primary" onClick={handleClickAnalyzeModeOff}>OFF</Button>
      </CardActions>
    </Collapse>
  )
}

const MarkAction = (props) => {
  const { classes, isMarkMode, insertStrings, handleMarkChange, handleClickRemoveMark, handleClickMarkModeOff, disabledRemoveMarkButton } = props
  return (
    <Collapse in={isMarkMode}>
      <CardActions className={classes.markAction}>
        <div className={classes.markTextFieldBox}>
          <FontDownloadIcon className={classes.markIcon}/>
          <Typography variant="subheading" color="inherit" className={classes.markTitle}><Word wid={WID.RENJU_BOARD_CARD.MARK_ACTION.MARK}/></Typography>
          <TextField
            className={classes.markTextField}
            InputLabelProps={{ shrink: true }}
            value={insertStrings}
            onChange={handleMarkChange}
            margin='normal'
            fullWidth
          />
        </div>
        <div className={classes.markButtonBox}>
          <Button color="primary" onClick={handleClickRemoveMark} disabled={disabledRemoveMarkButton}>REMOVE</Button>
          <Button color="primary" onClick={handleClickMarkModeOff}>OFF</Button>
        </div>
      </CardActions>
    </Collapse>
  )
}

const PuzzleModeActions = (props) => {
  const { classes, theme, isVisiblePuzzleSetControl, operationMode, editMode, bid, turnSelectMenu, handleClickStoneButton, blackTotal, whiteTotal, stoneType, isMarkMode } = props
  var enableStoneType = operationMode === constants.operationModeType.SET ? false : true
  var style = {
    stoneTypeBlack: { marginLeft: theme.spacing.unit },
    stoneTypeWhite: { marginLeft: theme.spacing.unit },
  }
  if (stoneType) {
    if (isMarkMode || operationMode === constants.operationModeType.SET) {
      style.stoneTypeBlack.borderColor = theme.palette.common.white
      style.stoneTypeWhite.borderColor = theme.palette.common.white
    }
    else if (stoneType === constants.stoneType.BLACK) {
      style.stoneTypeBlack.borderColor = theme.palette.grey[500]
      style.stoneTypeWhite.borderColor = theme.palette.common.white
    }
    else if (stoneType === constants.stoneType.WHITE) {
      style.stoneTypeBlack.borderColor = theme.palette.common.white
      style.stoneTypeWhite.borderColor = theme.palette.grey[500]
    }
  }
  else {
    style.stoneTypeBlack.borderColor = theme.palette.common.white
    style.stoneTypeWhite.borderColor = theme.palette.common.white
  }

  if (( isVisiblePuzzleSetControl === undefined ||
        isVisiblePuzzleSetControl === true
      ) &&
      operationMode === constants.operationModeType.EDIT
  ) {
    return (
      <Collapse in={editMode === constants.editModeType.PUZZLE}>
        <CardActions className={classes.stoneTypeAction}>
          {operationMode === constants.operationModeType.EDIT && (
            <TurnSelectMenu
              bid={bid}
              onChange={turnSelectMenu.handleSelected}
            />
          )}
          <div>
            <Button
              variant='outlined'
              style={style.stoneTypeBlack}
              disabled={!enableStoneType}
              onClick={handleClickStoneButton(constants.stoneType.BLACK)}
            >
              <LensIcon className={classes.stoneIcon}/>
              <Typography className={classes.stoneTotalNumber}>{blackTotal}</Typography>
            </Button>
            <Button 
              variant='outlined'
              style={style.stoneTypeWhite}
              disabled={!enableStoneType}
              onClick={handleClickStoneButton(constants.stoneType.WHITE)}
            >
              <PanoramaFishEyeIcon className={classes.stoneIcon}/>
              <Typography className={classes.stoneTotalNumber}>{whiteTotal}</Typography>
            </Button>
          </div>
        </CardActions>
      </Collapse>
    )
  }
  else {
    return (<div></div>)
  }
}

const RenjuBoardContent = (props) => {
  var { classes, bid, type, isVisibleGameInfo, editMode, gameInfo, settings, operationMode, renjuBoard, moves, movesHistory, movesAnalyze, marks, forbiddenPosition, analyzeStartNum, isAnalyzeMode, isSpecifiedWidth, cardWidth, afterRenjuBoardContent, beforeRenjuBoardContent, popupMessageContent, handleClick, isVisibleRenjuBoardHeaderContent, language } = props
  var fiveMoves, message, headerContent, move, boardSettings
      
  if (type === constants.boardType.GAME_ROOM) {
    moves = moves.filter(mv => mv.datetime !== undefined)
  }
  if (editMode === constants.editModeType.NORMAL) {
    switch (gameInfo.openingRule) {
      case constants.OPENING_RULE.SOOSYRV8:
        if ((moves.length === 8 && operationMode === constants.operationModeType.EDIT) || moves.length === 9) {
          fiveMoves = gameInfo.soosyrv8.fiveMoves
        }
        move = moves[moves.length - 1]
        switch (moves.length) {
          case 1: message = (<Word wid={WID.RENJU_BOARD_CARD.SOOSYRV8.MESSAGE_PUTS_ONE_OF_26_OPENINGS}/>); break
          case 2: message = (<Word wid={WID.RENJU_BOARD_CARD.SOOSYRV8.MESSAGE_PUTS_ONE_OF_26_OPENINGS}/>); break
          case 3: message = (<Word wid={WID.RENJU_BOARD_CARD.SOOSYRV8.MESSAGE_PUTS_ONE_OF_26_OPENINGS}/>); break
          case 4: message = (<Word wid={WID.RENJU_BOARD_CARD.SOOSYRV8.MESSAGE_PUTS_ONE_OF_26_OPENINGS}/>); break
          case 5: message = `${getWord(WID.RENJU_BOARD_CARD.SOOSYRV8.MESSAGE_SWAP, language)} : ${move.swap === true ? getWord(WID.RENJU_BOARD_CARD.SOOSYRV8.MESSAGE_YES, language) : getWord(WID.RENJU_BOARD_CARD.SOOSYRV8.MESSAGE_NO, language)}`; break
          case 6: message = (<Word wid={WID.RENJU_BOARD_CARD.SOOSYRV8.MESSAGE_PUTS_THE_4TH_MOVE_AND_DECLARE_NUMBER_OF_FIFTH_MOVES}/>); break
          case 7: message = `${getWord(WID.RENJU_BOARD_CARD.SOOSYRV8.MESSAGE_NUMBER_OF_FIFTH_MOVES, language)} : ${move.fiveMoveNumber}`; break
          case 8: message = `${getWord(WID.RENJU_BOARD_CARD.SOOSYRV8.MESSAGE_SWAP, language)} : ${move.swap === true ? getWord(WID.RENJU_BOARD_CARD.SOOSYRV8.MESSAGE_YES, language) : getWord(WID.RENJU_BOARD_CARD.SOOSYRV8.MESSAGE_NO, language)}`; break
          case 9: message = (<Word wid={WID.RENJU_BOARD_CARD.SOOSYRV8.MESSAGE_SELECT_FIFTH_MOVE_AND_PUT_SIXTH_MOVE}/>); break
          case 10: message = (<Word wid={WID.RENJU_BOARD_CARD.SOOSYRV8.MESSAGE_SELECT_FIFTH_MOVE_AND_PUT_SIXTH_MOVE}/>); break
          default: message = ''
        }
        headerContent = isVisibleRenjuBoardHeaderContent !== false ? (
          <React.Fragment>
            <text x={340} y={20} style={{fontSize: 16}} textAnchor="middle" dominantBaseline="central" fill='#222'>{message}</text>
            <text x={20} y={20} style={{fontSize: 16}} textAnchor="left" dominantBaseline="central" fill='#222'><Word wid={WID.RENJU_BOARD_CARD.SOOSYRV8.NAME}/></text>
          </React.Fragment>
        ): undefined
        break
      default:
        break
    }
  }
  boardSettings = {
    ...settings,
    isVisibleLastMoveMark: editMode === constants.editModeType.PUZZLE && operationMode === constants.operationModeType.EDIT ?
      false : settings.isVisibleLastMoveMark
  }
  
  return (
    <CardContent className={classes.cardContent} id={"card-content-" + bid}>
      <div className={classes.capturebox} id={"bid-" + bid}>
        {(isVisibleGameInfo === undefined || isVisibleGameInfo === true) && editMode === constants.editModeType.NORMAL && (
          <GameInfo {...props}/>
        )}
        {operationMode === constants.operationModeType.SET && (
          <PuzzleInfo {...props}/>
        )}
        {beforeRenjuBoardContent && beforeRenjuBoardContent}
        <div className={classes.renjuBoard}>
          {popupMessageContent && popupMessageContent}
          <div
            className={classes.board}
            onClick={handleClick}
            onContextMenu={renjuBoard.handleRightClick}
            id={"renjuboard" + bid}
          >
            <RenjuBoard {...{ moves, movesHistory, movesAnalyze, marks, forbiddenPosition, analyzeStartNum, isAnalyzeMode, isSpecifiedWidth, cardWidth, fiveMoves, headerContent, ...boardSettings }}/>
          </div>
        </div>
        {afterRenjuBoardContent && afterRenjuBoardContent}
      </div>
    </CardContent>
  )
}

const GameInfo = (props) => {
  const { theme, moves, gameInfo, settings, scale, language } = props
  const { title, blackPlayerName, whitePlayerName } = gameInfo
  const { isVisibleGameInfo, isVisibleTitle, isVisiblePlayerName, isVisibleGameResult } = settings
  const { gameEndNumber, gameResult } = gameInfo
  var stoneSize, styles, strList, gameResultStr, player1Stone, player2Stone, gameResultItem, stoneStyle

  stoneSize = Math.round(8 + ( 5 * scale ) )

  styles = {
    gameInfoBox: {
      padding: `0 ${theme.spacing.unit * 2}px`
    },
    flexCenterBox: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    title: {
      fontSize: (0.2 + ( 0.8 * scale )).toString(10) + 'rem',
      lineHeight: 2,
    },
    blackStone: {
      backgroundColor: 'black',
      borderRadius: '100px',
      width: stoneSize.toString(10) + 'px',
      height: stoneSize.toString(10) + 'px',
      marginRight: theme.spacing.unit * 2 * scale,
    },
    whiteStone: {
      backgroundColor: 'white',
      borderRadius: '100px',
      border: '1px solid black',
      width: (stoneSize - 2).toString(10) + 'px',
      height: (stoneSize - 2).toString(10) + 'px',
      marginRight: theme.spacing.unit * 2 * scale,
    },
    playerName: {
      fontSize: (0.2 + ( 0.8 * scale )).toString(10) + 'rem',
      lineHeight: 2,
    },
    gameResult: {
      fontSize: (0.2 + ( 0.8 * scale )).toString(10) + 'rem',
      lineHeight: 2,
    },
    playersBox: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    playerBox: {
      width: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }
  }

  if ( gameEndNumber !== '' && gameResult !== '' ) {
    strList = gameEndNumber.split('-');
    gameResultItem = constants.gameResultsItems.find(item => item.value === gameResult)
    gameResultStr = <Word wid={WID.RENJU_BOARD_CARD.GAME_INFO.GAME_RESULT} insert={{ number: strList[1], result: getWord(gameResultItem !== undefined ? gameResultItem.wid : '', language ) }}/>
    stoneStyle = strList[0] === 'black' ? styles.blackStone : styles.whiteStone;
  }
  if (0 === moves.filter(move => move.swap === true).length % 2) {
    player1Stone = <div style={styles.blackStone}></div>
    player2Stone = <div style={styles.whiteStone}></div>
  }
  else {
    player1Stone = <div style={styles.whiteStone}></div>
    player2Stone = <div style={styles.blackStone}></div>
  }
  
  if (isVisibleGameInfo === false) {
    return (<div></div>)
  }
  return (
    <div style={styles.gameInfoBox}>
      {isVisibleTitle && title !== '' && (
        <div style={styles.flexCenterBox}>
          <Typography style={styles.title}>{title}</Typography>
        </div>
      )}
      {isVisiblePlayerName && (blackPlayerName !== '' || whitePlayerName !== '') && (
        <div style={styles.playersBox}>
          <div style={styles.playerBox}>
            {player1Stone}
            <Typography style={styles.playerName}>{blackPlayerName}</Typography>
          </div>
          <div style={styles.playerBox}>
            {player2Stone}
            <Typography style={styles.playerName}>{whitePlayerName}</Typography>
          </div>
        </div>
      )}
      {isVisibleGameResult && gameResultStr !== undefined && (
        <div style={styles.flexCenterBox}>
          <div style={stoneStyle}></div>
          <Typography style={styles.gameResult}>{gameResultStr}</Typography>
        </div>
      )}
    </div>
  )
}

const PuzzleInfo = (props) => {
  const { classes, theme, puzzleInfo, scale, language, settings } = props
  const style = {
    turn: {
      marginRight: puzzleInfo && puzzleInfo.type !== '' ? theme.spacing.unit * 2 : 0,
      fontSize: `${(0.4 + ( 0.8 * scale )).toString(10)}rem`,
    },
    type: {
      marginLeft: puzzleInfo && puzzleInfo.type !== '' ? theme.spacing.unit * 2 : 0,
      fontSize: `${(0.4 + ( 0.8 * scale )).toString(10)}rem`,
    },
    level: {
      fontSize: `${(0.4 + ( 0.8 * scale )).toString(10)}rem`,
      marginTop: theme.spacing.unit * scale,
      textAlign: 'center',
      color: theme.palette.grey[800]
    },
  }
  var turnType = getTurnTypeText(puzzleInfo.turn, language, settings.skin)
  var puzzleType = getPuzzleTypeText(puzzleInfo.type, language)
  return (
    <div style={{padding: theme.spacing.unit * 2}}>
      <div className={classes.turnAndTypeBox}>
        <Typography variant='title' style={style.turn}>{turnType}</Typography>
        {puzzleType !== '' && (
          <React.Fragment>
            <Typography>{'/'}</Typography>
            <Typography variant='title' style={style.type}>{puzzleType}</Typography>
          </React.Fragment>
        )}
      </div>
      <div style={style.level}>{getLevelIcon(puzzleInfo.level, 16, 'text')}</div>
    </div>
  )
}

const stylesForControlButtonsActions = theme => ({
  controlButtons: {
    userSelect: "none",
    MozUserSelect: "none",
    position: "static",
    width: '100%',
    textAlign: "center"
  },
})

const ControlButtonsActions = withStyles(stylesForControlButtonsActions, { withTheme: true })(props => {
  const { classes, theme, width, bid, editMode, operationMode, isVisibleControlButtonsActions } = props
  var visible
  const { md } = getBreakpointsEnable(theme, width)

  visible = Boolean(
    md === true &&
    isVisibleControlButtonsActions !== false &&
    (
      editMode !== constants.editModeType.PUZZLE ||
      operationMode !== constants.operationModeType.EDIT
    )
  )

  return (
    <Collapse in={visible}>
      <CardActions>
        <div className={classes.controlButtons}>
          <ControlButtons bid={bid}/> 
        </div>
      </CardActions>
    </Collapse>
  )
})

const Dialogs = (props) => {
  const { editMode, settingsDialog, settings, moves, gameInfo, gameInfoDialog, operationMode, puzzleInfoDialog, shareDialog, card, bid, tweetDialog, downloadImageDialog, puzzleInfo, language } = props
  
  return (
    <React.Fragment>
      <SettingsDialog
        editMode={editMode}
        onEnter={settingsDialog.handleEnter(settings)}
        onOK={settingsDialog.handleOK}
      />
      <GameInfoDialog
        moves={moves}
        gameInfo={gameInfo}
        onOK={gameInfoDialog.handleOK}
      />
      <PuzzleInfoDialog
        disabled={Boolean(operationMode !== constants.operationModeType.EDIT)}
        onEnter={puzzleInfoDialog.handleEnter(puzzleInfo)}
        onOK={puzzleInfoDialog.handleOK}
      />
      <ShareDialog
        onEnter={shareDialog.handleEnter(card, language)}
      />
      <TweetDialog
        elementId={'bid-' + bid}
        onEnter={tweetDialog.handleEnter(card, language)}
        onExited={tweetDialog.handleExited}
      />
      <DownloadImageDialog 
        elementId={'bid-' + bid}
        onEnter={downloadImageDialog.handleEnter}
        onExited={downloadImageDialog.handleExited}
      />
    </React.Fragment>
  )
}

class RenjuBoardCard extends React.Component {

  componentDidMount () {
    const { resizeBoard } = this.props
    this.resizeBoard = (event) => {
      resizeBoard()
    }
    resizeBoard()
    window.addEventListener('resize', this.resizeBoard, true )
    window.addEventListener('orientationchange', this.resizeBoard, true)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.resizeBoard, true )
    window.removeEventListener('orientationchange', this.resizeBoard, true)
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.type === constants.boardType.GAME_ROOM && 
      JSON.stringify(nextProps.moves) !== JSON.stringify(this.props.moves) &&
      this.props.onChangeMove !== undefined
    ) {
      this.props.onChangeMove(nextProps.card, this.props.card)
    }
  }

  handleClick = (event) => {
    this.props.renjuBoard.handleClick(event)
  }

  render() {
    const { classes, width, bid, editMode, operationMode, isVisibleControlButtonsActions, customHeader, customContent, customFooter } = this.props
    var argProps = { ...this.props }
    delete argProps.classes

    return (
      <React.Fragment>
        <Card className={classes.card}>
          {customHeader && customHeader}
          <RenjuBoardCardHeader {...this.props}/>
          {customContent && customContent}
          <AnalyzeAction {...this.props}/>
          <MarkAction {...this.props}/>
          <PuzzleModeActions {...this.props}/>
          <RenjuBoardContent {...{...this.props, handleClick: this.handleClick}}/>
          <ControlButtonsActions {...{ width, bid, editMode, operationMode, isVisibleControlButtonsActions }}/>
          {customFooter && customFooter}
        </Card>
        <Dialogs {...this.props}/>
      </React.Fragment>
    );
  }
}

export default withStyles(styles, { withTheme: true })(withSize()(RenjuBoardCard))



// WEBPACK FOOTER //
// ./src/components/Common/RenjuBoardCard/RenjuBoardCard.js